import { combineReducers } from 'redux';
import { reducer as lookup } from './lookupModule';

export default combineReducers({ lookup });
